<template>
  <v-text-field
      ref="v_text_field"
      v-bind="$attrs"
      dense
      outlined
      :clearable="clearable"
      @input="onInput"
      @keydown.enter="onEnter()"
      @click:prepend="$emit('click:prepend', $event)"
      :filled="filled || readonly"
      :readonly="readonly"
  >
    <template v-slot:prepend>
      <slot name="prepend"></slot>
    </template>
  </v-text-field>
</template>

<script>

export default {
  name: 'CommonFieldString',
  inheritAttrs: false,
  props: {
    clearable: {default: false},
    enterInput: {default: null},
    readonly: {default: false},
    filled: {default: false},
  },

  components: {},

  computed: {},

  methods: {
    onEnter() {
      if (!!this.enterInput)
        this.enterInput()
    },
    onInput(event) {
      // console.log('onInput', event)
      if (event === '')
        this.$emit('input', null)
      else
        this.$emit('input', event)
    },
  },

  async mounted() {
  },

  data() {
    return {}
  }
}
</script>

<style scoped lang="scss">
.no-spin input[type='number'] {
  -moz-appearance: textfield;
  /*width: 50px;*/
}

</style>
